const INNITIAL_STATE = {
  parcelas: {},
  datas: {}
};

/** Retorna o estado atualizado */
export default function acordo(state = INNITIAL_STATE, action) {
  switch (action.type) {
    case "PARCELA_CHANGE":
      const values = action.parcelas; // objeto com o valor das parcelas atualizado

      return {
        ...state,
        parcelas: values
      };
    case "DATA_CHANGE":
      return {
        ...state,
        datas: action.datas
      };
    default:
      return {
        ...state
      };
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/acordo.js